import { curry, apply, path } from 'ramda';

export const onCtaClick = (ctaButton, callback, el) => {
  el.preventDefault();
  const url = ctaButton?.link?.url;
  if (!ctaButton?.show || typeof window === 'undefined') return;
  if (callback) callback(el);
  if (ctaButton?.link?.linkClass === 'INTERNAL') {
    window.location.href = url;
    return;
  }
  const win = window.open(`/external?url=${url}`, '_blank');
  win.focus();
};

export const onKGIPopupEvent = (list, data, action) => {
  const eventCode = {
    event: 'productMiniFunnel',
    eventDetails: {
      actionField: { action, list },
      products: [
        {
          brand: data?.provider?.providerName,
          name: data?.productName,
          id: data?.title,
          category: data?.__typename,
          position: data?.index + 1,
        }],
    },
  };
  return eventCode;
};

export const onKGIPopupApplyButtonClick = (pageName, cardData) => {
  const verticalCode = {
    ecommerce: {
      click: {
        actionField: {
          action: 'click',
          list: pageName,
        },
        filter: [
          {
            filterAmount: 300000,
            filterPeriod: 48,
            filterProvider: cardData?.brand,
            filterSortby: 'REPAYMENT',
          },
        ],
        products: [cardData],
      },
    },
    event: 'productClick',
  };
  return verticalCode;
};

export const ramdaDebounce = curry((immediate, timeMs, fn) => () => {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null;
      if (!immediate) {
        apply(fn, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, timeMs);
    if (callNow) {
      apply(fn, args);
    }
    return timeout;
  };
});

export const getTextBlockList = (nodeName, data) => {
  if (!nodeName) return [];
  return path([nodeName, 0, 'text'], data) || [];
};

export const getImageAndLinkList = (nodeName, data) => {
  if (!nodeName) return [];
  return path([nodeName, 0, 'imageLink'], data) || [];
};
